export const TYPE_OFFER = {
  new: {
    path: '/available-credit-cards'
  },
  'limit-increase': {
    path: '/limit-increase/request'
  }
}
